import React from "react";
import PropTypes from "prop-types";

// Components
import LocationItem from "../LocationItem";

// UTIL
// TODO - Put this function in server, so this returns items already formatted.
// Values can be used here, and AutoCompleteField component.
function formatLocation(location) {
  const { type, cityid_ppn, iata } = location;

  return type === "airport"
    ? { locationId: iata, locationIdType: "iata", ...location }
    : { locationId: cityid_ppn, locationIdType: "cityid_ppn", ...location };
}
function formatLocations(locations) {
  return locations.map(location => formatLocation(location));
}

const LocationItemList = ({
  locations,
  radioButtonName,
  tripType,
  handleRadioClick
}) => {
  if (locations) {
    const formattedLocations = formatLocations(locations);

    return formattedLocations.map(location => (
      <LocationItem
        tripType={tripType}
        radioButtonName={radioButtonName}
        key={location.locationId}
        handleRadioClick={handleRadioClick}
        {...location}
      />
    ));
  }
  return [];
};

LocationItemList.propTypes = {
  locations: PropTypes.array.isRequired
};

export default LocationItemList;



// WEBPACK FOOTER //
// ./src/scenes/LocationSuggestionsPage/components/LocationItemList/index.js